const UsageMetaItem = ({ label, value }) => {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs text-gray-400">{label}</span>

      <span className="text-sm font-medium text-gray-700">{value}</span>
    </div>
  )
}

export default UsageMetaItem
